import React from 'react';
import { useRouter } from '@uirouter/react';
import { HtmlString, Modal } from '@adjust/dashboard-components';

import './CreateUserPopup.scss';

export interface CreateUserPopupProps {
  routerProps: {
    backPath: string;
    defaultPath: string;
    advancedPermissionsPath: string;
  };
}

export const CreateUserPopup: React.FC<CreateUserPopupProps> = ({ routerProps }) => {
  const router = useRouter();
  const { backPath, defaultPath, advancedPermissionsPath } = routerProps;

  const onCancel = () => {
    router.stateService.go(backPath);
  };

  const onStandard = () => {
    router.stateService.go(defaultPath, undefined, { location: 'replace' });
  };

  return (
    <Modal isOpen extraClasses="create-user-popup" extraOverlayClasses="create-user-popup__overlay">
      <div>
        <button onClick={onCancel} className="close-btn">
          <i className="icon-times" />
        </button>

        <h3>{t('new-user.dialog.title.permissions')}</h3>

        <p>
          <HtmlString>{t('new-user.dialog.description.permissions')}</HtmlString>
        </p>

        <div className="flex-box-row">
          <a className="btn flex-one" href={advancedPermissionsPath}>
            {t('label.advanced')}
          </a>

          <button className="flex-one" onClick={onStandard}>
            {t('label.standard')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
